import { has, pick } from 'lodash';

export const getActiveStatus = (queryString, path, queryRequest) => {
  const queryHas = has(queryString, queryRequest);

  if (queryHas) {
    const statusNumber = pick(queryString, queryRequest);
    return Number(statusNumber[queryRequest]);
  }

  return path === '/users' || path === '/orders' || path === '/updates' ? null : 0;
};

export const getActiveAssign = (queryString, path) => {
  const queryHas = has(queryString, 'assignee');

  if (queryHas) {
    const statusNumber = pick(queryString, 'assignee');
    return Number(statusNumber.assignee);
  }

  return path === '/users' ? null : 0;
};

export const generateStatuses = (submenuStatuses, t) => {
  if (submenuStatuses) {
    return submenuStatuses;
  }

  return [t('ActionsList.Pending'), t('ActionsList.Answered'), t('ActionsList.Closed')];
};
